<template>
  <div>
    <slot name="title">
      <div class="text-body-2 text-secondary--text d-flex align-center mb-1">
        {{ t('Стаж', options) }}

        <v-btn
          icon
          text
          small
          color="text-info"
          class="ml-1"
          @click="openDialog"
        >
          <v-icon size="20">
            ui-icon-circle-info
          </v-icon>
        </v-btn>
        <v-overlay
          :value="isDialogOpened"
          @click="closeDialog"
        />
        <DialogBottomSheet
          :is-visible="isDialogOpened"
          :width="isMobile ? undefined : 375"
          hide-overlay
          attach=".vue-the-doctors-filters .v-application"
          content-class="rounded-0"
          @dialog-bottom-sheet:change-visible="closeDialog"
        >
          <v-card
            tile
            class="px-2 py-4"
          >
            <div class="pa-2 mb-2">
              <div class="text-h6 mb-4">
                {{ t('Стаж', options) }}
              </div>
              <div class="text-subtitle-2">
                {{ t('5–10 лет', options) }}
              </div>
              <div class="text-body-2 mb-4">
                {{ t('Есть опыт, наиболее открыты к новым достижениям медицины.', options) }}
              </div>
              <div class="text-subtitle-2">
                {{ t('10–15 лет', options) }}
              </div>
              <div class="text-body-2 mb-4">
                {{ t('Достаточный опыт, как правило владеют методиками общения с пациентами.', options) }}
              </div>
              <div class="text-subtitle-2">
                {{ t('Более 15 лет', options) }}
              </div>
              <div class="text-body-2">
                {{ t('Большой фактический опыт, чаще выбирают проверенные методики лечения.', options) }}
              </div>
            </div>
            <v-btn
              color="primary"
              block
              depressed
              @click="closeDialog"
            >
              {{ t('Понятно', options) }}
            </v-btn>
          </v-card>
        </DialogBottomSheet>
      </div>
    </slot>
    <v-chip-group
      :value="doctorFiltersState.experience"
      column
      active-class="primary"
      @change="handleChangeChip"
    >
      <v-chip
        v-for="(chip, i) in experienceChips"
        :key="i"
        :value="chip.value"
        :color="chip.value === doctorFiltersState.experience ? 'primary' : 'bg-primary'"
        :text-color="chip.value === doctorFiltersState.experience ? 'bg-gray-0' : 'primary'"
      >
        {{ t(chip.name, { ...options, age: chip.value }) }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ChipGroupExperience')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const isMobile = window.MOBILE_VERSION

const experienceChips: ({ name: string, value: Filters['experience'] })[] = [
  { name: 'от {age} лет', value: 5 },
  { name: 'от {age} лет', value: 10 },
  { name: 'от {age} лет', value: 15 },
]

const handleChangeChip = (experience: Filters['experience']) => {
  filtersStore.updateUnsavedFilters({ experience })
  emit('input', {
    ...doctorFiltersState.value,
    experience,
  })
}
</script>
